import React, {useEffect, useState} from 'react'
import ShowDesignVariantDetail from "../common/show-design-variant-detail";
import ShowParentProductColorList from "../common/show-parent-product-color-list";
import ShowImage from "../../../image/show-image";
import {getSingleDesignVariant, updateSingleDesignVariant} from "../../services/design-variant-data-service";
import _ from "lodash";
import {
    extractColorsFromDesignVariant,
} from "../../utils/design-variant-util";
import ShowTags from "../common/show-tags";
import PreviewDesignVariantImage from "./preview-design-variant-image";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {DESIGN_KEY_PREFIX} from "../../constants/design.constant";
import {saveAs} from "file-saver";
import UpdateDesignVariantStatus from "../common/update-design-variant-status";
import {updateSingleDesign} from "../../services/design-data-service";
import ApplyParentProductColorList from "../common/apply-parent-product-color-list";
import {processDesignVariantStatistics} from "../../utils/design-util";
import {searchImages} from "../../../common/services/image-data-service";
import {appConfig} from "../../../firebase/client-app";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {prepareDesignTags} from "../../utils/design-tag-util";

const PublisherDesignVariantDetailList = ({
                                              designDetail,
                                              setDesignDetail,
                                              selectedVariant,
                                              setSelectedVariant,
                                              parentProduct,
                                              quoteDetail,
                                              allTags
                                          }) => {
    const [designVariantDetail, setDesignVariantDetail] = useState(null);
    const [tagDetailList, setTagDetailList] = useState(null);
    const [designTagDetailList, setDesignTagDetailList] = useState(null);
    const [redBubbleTagDetailList, setRedBubbleTagDetailList] = useState(null);
    const [instagramTagDetailList, setInstagramTagDetailList] = useState(null);
    const [instagramTags, setInstagramTags] = useState(null);
    const [statusChangeInProgress, setStatusChangeInProgress] = useState(false);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [selectedProductColor, setSelectedProductColor] = useState(null);
    const [redBubbleLabel, setRedBubbleLabel] = useState(null);
    const [combinedDescription, setCombinedDescription] = useState(null);
    const [imagesList, setImagesList] = useState(null);

    const getDesignVariantById = () => {
        if (selectedVariant) {
            getSingleDesignVariant(selectedVariant?.id)
                .then(async response => {
                    const designVariantDetailData = _.cloneDeep(response.data());
                    designVariantDetailData.id = response.id;

                    if (!designVariantDetailData.variantIndex) {
                        designVariantDetailData.variantIndex = _.parseInt(_.replace(designVariantDetailData.key, DESIGN_KEY_PREFIX.VARIANT + '-', ''));
                    }

                    await getImageList(designVariantDetailData);
                    setDesignVariantDetail(designVariantDetailData);

                    if (designVariantDetailData?.colors) {
                        setSelectedProductColor(designVariantDetailData?.colors[0]);
                    }

                    prepareCombinedDescription();
                });
        }
    }

    const getImageList = async (designVariantDetail) => {
        if (!_.isEmpty(designVariantDetail?.images)) {
            const imageIds = _.map(designVariantDetail?.images, 'id');
            const searchCriteriaList = [];
            searchCriteriaList.push({field: 'id', condition: 'in', value: imageIds});

            const imagesListResult = await searchImages(searchCriteriaList);
            setImagesList(imagesListResult);
        }
    }

    const prepareCombinedDescription = () => {
        const existingQuoteDetail = {...quoteDetail};
        const existingParentProduct = {...parentProduct};

        let tempCombinedDescription = '';

        if (existingQuoteDetail?.description) {
            tempCombinedDescription += existingQuoteDetail?.description;
        }

        if (existingParentProduct?.description) {
            tempCombinedDescription += (_.isEmpty(tempCombinedDescription) ? '' : '\n\n') + existingParentProduct?.description;
        }

        setCombinedDescription(tempCombinedDescription);
    }

    useEffect(() => {
        getDesignVariantById();
    }, [selectedVariant]);

    useEffect(() => {
        if (designVariantDetail && allTags) {
            const {
                tagDetailList,
                redBubbleTagDetailList,
                designTagDetailList
            } = prepareDesignTags(allTags, designDetail, parentProduct, quoteDetail, designVariantDetail, imagesList);

            setTagDetailList(tagDetailList);
            prepareInstagramTagDetailList(tagDetailList);

            setRedBubbleTagDetailList(redBubbleTagDetailList);
            prepareRedBubbleLabel();

            setDesignTagDetailList(designTagDetailList);
            // updateDesignTagsInDesign(designTagDetailList);
        }
    }, [designVariantDetail, allTags]);

    const prepareRedBubbleLabel = () => {
        setRedBubbleLabel(designDetail?.quoteName + ' | ' + designDetail?.themeName + ' - #' + designVariantDetail?.variantIndex);
    }

    const prepareInstagramTagDetailList = (tagDetailList) => {
        let allTagList = _.map(tagDetailList, tagDetail => {
            return {
                startText: '#' + _.toLower(_.camelCase(tagDetail?.startText))
            }
            /*return {
                startText: '#' + _.upperFirst(_.camelCase(tagDetail?.startText))
            }*/
        });

        let instagramTags: any = _.shuffle(_.compact(_.uniq(_.map(allTagList, 'startText'))));
        instagramTags = (instagramTags.toString().split(',')).join(' ');

        setInstagramTagDetailList(allTagList);
        setInstagramTags(instagramTags);
    }

    const handleSelectDesignVariantChanges = async (event) => {
    }

    const downloadImageFile = () => {
        fetch(designVariantDetail?.imageDetail?.fileUrl)
            .then(res => res.blob())
            .then(blob => {
                saveAs(blob, designVariantDetail?.imageDetail?.name);
            });
    }

    const updateInstagramTags = async () => {
        setSaveInProgress(true);
        const existingDesignVariant = {...designVariantDetail};
        updateTagsInDesignVariant(existingDesignVariant);

        setDesignVariantDetail(existingDesignVariant);
        await updateSingleDesignVariant(existingDesignVariant);
        setSaveInProgress(false);
    }

    const updateTagsInDesignVariant = (existingDesignVariant) => {
        // existingDesignVariant.instagramTagDetailList = instagramTagDetailList;
        existingDesignVariant.instagramTags = instagramTags;
        existingDesignVariant.redBubbleLabel = redBubbleLabel;
    }

    const markAsPublished = async () => {
        setStatusChangeInProgress(true);

        setTimeout(async () => {
            const existingDesignVariant = {...designVariantDetail};
            existingDesignVariant.status = 'published';

            updateTagsInDesignVariant(existingDesignVariant);

            setDesignVariantDetail(existingDesignVariant);
            await updateSingleDesignVariant(existingDesignVariant);

            const existingDesignDetail = {...designDetail};
            const existingVariants = existingDesignDetail.variants;

            const variantIndex = _.findIndex(existingVariants, ['key', existingDesignVariant.key]);
            existingVariants[variantIndex].status = existingDesignVariant.status;
            existingDesignDetail.variants = existingVariants;
            processDesignVariantStatistics(existingDesignDetail);
            setDesignDetail(existingDesignDetail);

            await updateSingleDesign(existingDesignDetail);

            setStatusChangeInProgress(false);
        }, 100);
    }

    const updateDesignTagsInDesign = async (designTagDetailList) => {
        const existingDesignDetail = {...designDetail};
        existingDesignDetail.designTags = _.compact(_.uniq(_.map(designTagDetailList, 'startText')));

        setDesignDetail(existingDesignDetail);
        await updateSingleDesign(existingDesignDetail);
    }

    return (
        <>
            <div className="">

                {designVariantDetail &&
                    <>

                        <div className="flex justify-between mb-4">
                            <div className="flex justify-start items-center">
                                <ShowDesignVariantDetail
                                    hideName={false}
                                    designVariantDetail={designVariantDetail}/>
                            </div>

                            <div className="">
                                <div className="flex justify-center items-center">
                                    <div className="mr-2 mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>

                                    <div>
                                        <button
                                            className={`py-2 px-4 button-gray mr-2`}
                                            onClick={updateInstagramTags}>
                                            <span>Update Instagram Tags</span>
                                        </button>
                                    </div>

                                    <UpdateDesignVariantStatus
                                        designVariant={designVariantDetail}
                                        markAsPublished={markAsPublished}
                                        markAsReadyToPublish={undefined}
                                        markAsInDesign={undefined}
                                        statusChangeInProgress={statusChangeInProgress}/>
                                </div>
                            </div>


                        </div>

                        <div className="overflow-y-scroll form-container design-variant-detail-container">
                            <table className="w-full">
                                <tbody className="">

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Variant</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div
                                            className="text-xl font-bold text-purple-700 px-2">
                                            # {designVariantDetail?.variantIndex}
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">

                                    </td>
                                </tr>

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Label</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div className="text-xl ml-2 flex text-purple-700 font-semibold">
                                            {designVariantDetail?.label}
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard value={designVariantDetail?.label}/>
                                        </div>
                                    </td>
                                </tr>

                                {/*<tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">RedBubble Label</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div className="text-xl ml-2 flex text-purple-700 font-semibold">
                                            {redBubbleLabel}
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard
                                                value={redBubbleLabel}/>
                                        </div>
                                    </td>
                                </tr>*/}

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Quote</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div className="text-lg ml-2 flex text-purple-700">
                                            {designDetail?.quoteName}
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard value={designDetail?.quoteName}/>
                                        </div>
                                    </td>
                                </tr>

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Theme</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div className="text-lg ml-2 flex text-purple-700">
                                            {designDetail?.themeName}
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard value={designDetail?.themeName}/>
                                        </div>
                                    </td>
                                </tr>

                                {/*<tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Parent Product</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div className="text-lg ml-2 flex text-purple-700">
                                            {designDetail?.parent}
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard value={designDetail?.parent}/>
                                        </div>
                                    </td>
                                </tr>

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Category</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div className="text-lg ml-2 flex text-purple-700">
                                            {designDetail?.category}
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard value={designDetail?.category}/>
                                        </div>
                                    </td>
                                </tr>

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Product Type</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div className="text-lg ml-2 flex text-purple-700">
                                            {designDetail?.productType}
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard value={designDetail?.productType}/>
                                        </div>
                                    </td>
                                </tr>*/}

                                {/*<tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Colors</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <ShowParentProductColorList parentProduct={designVariantDetail}/>
                                    </td>
                                    <td className="w-48 p-2">

                                    </td>
                                </tr>*/}

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Design Variant Tags</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <ShowTags tagDetailList={_.shuffle(tagDetailList)}/>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard
                                                value={_.shuffle(_.compact(_.uniq(_.map(tagDetailList, 'startText'))))}/>
                                        </div>
                                    </td>
                                </tr>

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Design Tags</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <ShowTags tagDetailList={_.shuffle(designTagDetailList)}/>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard
                                                value={_.join(_.shuffle(_.compact(_.uniq(_.map(designTagDetailList, 'startText')))), ', ')}/>
                                        </div>
                                    </td>
                                </tr>

                                {/*<tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">RedBubble Tags</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <ShowTags tagDetailList={_.shuffle(redBubbleTagDetailList)}/>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard
                                                value={_.shuffle(_.compact(_.uniq(_.map(redBubbleTagDetailList, 'startText'))))}/>
                                        </div>
                                    </td>
                                </tr>*/}

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Instagram Tags</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <ShowTags tagDetailList={_.shuffle(instagramTagDetailList)}/>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard
                                                value={instagramTags}/>
                                        </div>
                                    </td>
                                </tr>

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Quote Description</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                    <textarea
                                        id="description"
                                        name="description"
                                        rows={10}
                                        value={quoteDetail?.description || ''}
                                        onChange={handleSelectDesignVariantChanges}
                                        className="text-area-field"/>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard value={quoteDetail?.description}/>
                                        </div>
                                    </td>
                                </tr>

                                <tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold font-bold">Combined Description</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                    <textarea
                                        id="combinedDescription"
                                        name="combinedDescription"
                                        rows={10}
                                        value={combinedDescription || ''}
                                        onChange={handleSelectDesignVariantChanges}
                                        className="text-area-field"/>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <CopyDataToClipboard value={combinedDescription}/>
                                        </div>
                                    </td>
                                </tr>

                                {/*<tr className="border border-gray-400">
                                    <td className="w-48 p-2 border-r border-gray-400">
                                        <div className="field-label-bold">Image</div>
                                    </td>
                                    <td className="w-3/4 p-2 border-r border-gray-400">
                                        <div className="flex justify-between">
                                            {!designVariantDetail?.imageDetail?.fileUrl &&
                                                <button type="button" className="border p-4 rounded bg-white h-full"
                                                        disabled>
                                                    <div className="flex items-center justify-center">
                                                        <div
                                                            className="w-12 h-12 border-b-2 border-blue-900 rounded-full animate-spin"></div>
                                                    </div>
                                                </button>
                                            }

                                            {designVariantDetail?.imageDetail?.fileUrl &&

                                                <PreviewDesignVariantImage
                                                    src={designVariantDetail?.imageDetail?.fileUrl} width={300}
                                                    mode={'fit'}
                                                    designVariantDetail={designVariantDetail}
                                                    selectedProductColor={selectedProductColor}/>

                                            }

                                            <div
                                                className="w-full border border-gray-500 bg-white ml-2 rounded overflow-y-scroll">
                                                <ApplyParentProductColorList
                                                    parentProduct={designVariantDetail}
                                                    selectedProductColor={selectedProductColor}
                                                    setSelectedProductColor={setSelectedProductColor}/>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="w-48 p-2">
                                        <div className="flex justify-around">
                                            <button
                                                className="button-outline-gray px-4 py-1"
                                                onClick={downloadImageFile}>
                                                Download
                                            </button>
                                        </div>
                                    </td>
                                </tr>*/}

                                </tbody>
                            </table>
                        </div>

                    </>
                }

            </div>
        </>
    )
}

export default PublisherDesignVariantDetailList
